<template>
  <EditorDeckModalsDeckSelector
    :key="showing.toString()"
    :deck-id="deck.id"
    :showing="showing"
    :company-id="deck.company.id"
    @export="exportDeck"
    @close="$emit('close')"
    @cancel="$emit('cancel')"
  >
    <template #header>
      <VModalHeader>
        <template #title>Choose a 3D Presentation</template>
        <template #sub-title>Export slides to another 3D Presentation</template>
      </VModalHeader>
    </template>

    <div v-if="isInternalAdmin && anyModelSlides" class="flex gap-2 border-gray-300 border-t py-4">
      <VCheckbox id="cloneModel" v-model="duplicateModelOnExport" class="mt-px" />
      <label class="text-sm" for="cloneModel">
        <div>Create new model IDs during export</div>
        <div class="text-gray-500">This will create new model IDs when bringing over all scenes from the existing models</div>
        <div v-if="loading" class="pt-2 text-sm">
          <FontAwesomeIcon class="text-gray-800 mr-2" icon="circle-notch" spin size="1x" />
          Duplicating&hellip;
        </div>
      </label>
    </div>
    <div v-else-if="loading" class="pt-2 text-sm">
      <FontAwesomeIcon class="text-gray-800" icon="circle-notch" spin size="1x" />
      Duplicating&hellip;
    </div>
  </EditorDeckModalsDeckSelector>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'
import { computed, ref, watch } from 'vue'

import type { Deck, Slide, IncludeCompany } from '@/entities/deck'

const props = defineProps({
  slidesToExport: {
    type: Array as PropType<Slide[]>,
    default: null,
  },
  companyId: {
    type: [String, Number],
    required: true,
  },
  showing: {
    type: Boolean,
    default: false,
  },
  deck: {
    type: Object as PropType<EditDeck>,
    required: true,
  },
})

const emit = defineEmits(['close', 'cancel', 'export'])

const { hasRole } = useUser()
const loading = ref(false)
const duplicateModelOnExport = ref(false)
const isInternalAdmin = computed(() => hasRole('internal_admin'))
const anyModelSlides = computed(() => props.slidesToExport?.some(slide => slide.type === 'M'))

watch(
  () => props.showing,
  showing => {
    if (showing) {
      loading.value = false
      duplicateModelOnExport.value = false
    }
  }
)

function exportDeck(deck: Deck) {
  loading.value = true
  emit('export', { deck, duplicateModelOnExport: duplicateModelOnExport.value })
}
</script>
